// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { countUpNumber, inViewAnm, lenisPageScroll } from './libs/Scroll';
import { drawer, fixedHeader, megaMenu, reset } from './libs/Header';
import { accordionFunc } from './libs/Accordion';
import { addAutoFunc, numKeyFunc } from './libs/Form';
import { mv } from './libs/Mv';
import { mvSlider, woksSlider } from './libs/Slider';
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
// import { slider } from './libs/Slider';
// import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  reset();
  viewport();
  mv();
  fixedHeader();
  drawer();
  addAutoFunc();
  numKeyFunc();
  lenisPageScroll();
  accordionFunc();
  megaMenu();
  countUpNumber();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  // slider();
  mvSlider();
  inViewAnm();
  woksSlider();
});
